import Trans from 'next-translate/Trans';
import { ReactNode } from 'react';

import {
  Box,
  Icon,
  InputSwitch,
  LinkTranslatedStyledAsLink,
  Tooltip,
  Typography,
} from '@core/component';
import { InputSwitchProps } from '@core/component/interface';
import { Translate } from '@core/constant';
import {
  EActionAttribute,
  EColor,
  EFontWeight,
  EIcon,
  ERouting,
  ESize,
  ETypographyVariant,
} from '@core/type';

const LinkDedicated = ({ children }: { children?: ReactNode }) => (
  <LinkTranslatedStyledAsLink
    keyRoute={ERouting.AUTO_SAVINGS}
    variant={ETypographyVariant.BODY3}
    color={EColor.ACCENT}
  >
    {children}
  </LinkTranslatedStyledAsLink>
);

const TooltipWhatIsAutoSavings = ({ children }: { children?: ReactNode }) => {
  return (
    <Tooltip
      width="320px"
      content={
        <Trans
          i18nKey={`${Translate.page.PRODUCT_SHOW}:tooltips.whatIsAutoSavings.content`}
          components={{
            boldText: (
              <Typography
                variant={ETypographyVariant.BODY3}
                marginBottom="16px"
                fontWeight={EFontWeight.BOLD}
              />
            ),
            dedicatedLink: <LinkDedicated />,
            paragraph: <Typography variant={ETypographyVariant.BODY3} marginBottom="16px" />,
            paragraphLast: <Typography variant={ETypographyVariant.BODY3} />,
          }}
        />
      }
    >
      <Typography as={EActionAttribute.SPAN} textDecoration={'underline'} whiteSpace={'nowrap'}>
        {children}
        <Box
          paddingRight={'24px'}
          as={EActionAttribute.SPAN}
          position={'relative'}
          lineHeight={'18px'}
        >
          <Icon
            type={EIcon.INFO}
            color={EColor.INFO}
            size={ESize.XXS}
            position={'absolute'}
            bottom={'8px'}
            right={'2px'}
          />
        </Box>
      </Typography>
    </Tooltip>
  );
};

export const SwitchAutoSavings = (props: InputSwitchProps) => (
  <Box
    display={'flex'}
    justifyContent={'space-between'}
    gap={'16px'}
    maxWidth={'267px'}
    marginTop={'30px'}
  >
    <Box>
      <Trans
        i18nKey={`${Translate.page.PRODUCT_SHOW}:activeAutoSavings`}
        components={{
          tooltip: <TooltipWhatIsAutoSavings />,
        }}
      />
    </Box>

    <Box>
      <InputSwitch {...props} />
    </Box>
  </Box>
);
